/* React base component */
import { Component } from "react"

/* Line icon component */
import Icon from "./Icon"

/* Component Stars */
class Stars extends Component {

    render = () => {
        const value = this.props.value || 0
        const size = this.props.size || 14
        const stars = []
        for (let i = 1; i <= 5; i++) {
            stars.push(<Icon key={`${i}`} name="star" size={size} fill={i <= Math.round(value) ? "currentColor" : "none"} />)
        }
        return <span className="review__stars">{stars}</span>
    }
}

/* Export */
export default Stars
